import React from 'react';
import Icon from 'react-web-vector-icons';

const Pagination = ({ 
	currentPage, 
	totalPages, 
	totalItems, 
	pageSize, 
	onPageChange, 
	onPageSizeChange,
	showPageSizeSelector = true,
	showInfo = true,
	entityLabel = 'entries'
}) => {
	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			onPageChange(newPage);
		}
	};

	const renderPageNumbers = () => {
		const pages = [];
		
		if (totalPages <= 7) {
			// Show all pages if less than 7 pages
			for (let i = 1; i <= totalPages; i++) {
				pages.push(
					<button
						key={i}
						onClick={() => handlePageChange(i)}
						style={{
							padding: '8px 6px',
							border: 'none',
							backgroundColor: 'transparent',
							color: currentPage === i ? '#40A0C1' : '#6A8991',
							fontWeight: currentPage === i ? 700 : 400,
							borderRadius: '4px',
							fontSize: 14,
							cursor: 'pointer',
						}}
					>
						{i}
					</button>
				);
			}
		} else {
			// Logic for many pages with "..." dots
			if (currentPage <= 4) {
				// Show: 1 2 3 4 5 ... N
				for (let i = 1; i <= 5; i++) {
					pages.push(
						<button
							key={i}
							onClick={() => handlePageChange(i)}
							style={{
								padding: '8px 6px',
								border: 'none',
								backgroundColor: 'transparent',
								color: currentPage === i ? '#40A0C1' : '#6A8991',
								fontWeight: currentPage === i ? 700 : 400,
								borderRadius: '4px',
								fontSize: 14,
								cursor: 'pointer',
							}}
						>
							{i}
						</button>
					);
				}
				pages.push(
					<span key="dots1" style={{ padding: '8px 4px', color: '#6A8991' }}>...</span>
				);
				pages.push(
					<button
						key={totalPages}
						onClick={() => handlePageChange(totalPages)}
						style={{
							padding: '8px 6px',
							border: 'none',
							backgroundColor: 'transparent',
							color: '#6A8991',
							fontWeight: 400,
							borderRadius: '4px',
							fontSize: 14,
							cursor: 'pointer',
						}}
					>
						{totalPages}
					</button>
				);
			} else if (currentPage >= totalPages - 3) {
				// Show: 1 ... N-4 N-3 N-2 N-1 N
				pages.push(
					<button
						key={1}
						onClick={() => handlePageChange(1)}
						style={{
							padding: '8px 6px',
							border: 'none',
							backgroundColor: 'transparent',
							color: '#6A8991',
							fontWeight: 400,
							borderRadius: '4px',
							fontSize: 14,
							cursor: 'pointer',
						}}
					>
						1
					</button>
				);
				pages.push(
					<span key="dots2" style={{ padding: '8px 4px', color: '#6A8991' }}>...</span>
				);
				for (let i = totalPages - 4; i <= totalPages; i++) {
					pages.push(
						<button
							key={i}
							onClick={() => handlePageChange(i)}
							style={{
								padding: '8px 6px',
								border: 'none',
								backgroundColor: 'transparent',
								color: currentPage === i ? '#40A0C1' : '#6A8991',
								fontWeight: currentPage === i ? 700 : 400,
								borderRadius: '4px',
								fontSize: 14,
								cursor: 'pointer',
							}}
						>
							{i}
						</button>
					);
				}
			} else {
				// Show: 1 ... current-1 current current+1 ... N
				pages.push(
					<button
						key={1}
						onClick={() => handlePageChange(1)}
						style={{
							padding: '8px 6px',
							border: 'none',
							backgroundColor: 'transparent',
							color: '#6A8991',
							fontWeight: 400,
							borderRadius: '4px',
							fontSize: 14,
							cursor: 'pointer',
						}}
					>
						1
					</button>
				);
				pages.push(
					<span key="dots3" style={{ padding: '8px 4px', color: '#6A8991' }}>...</span>
				);
				for (let i = currentPage - 1; i <= currentPage + 1; i++) {
					pages.push(
						<button
							key={i}
							onClick={() => handlePageChange(i)}
							style={{
								padding: '8px 6px',
								border: 'none',
								backgroundColor: 'transparent',
								color: currentPage === i ? '#40A0C1' : '#6A8991',
								fontWeight: currentPage === i ? 700 : 400,
								borderRadius: '4px',
								fontSize: 14,
								cursor: 'pointer',
							}}
						>
							{i}
						</button>
					);
				}
				pages.push(
					<span key="dots4" style={{ padding: '8px 4px', color: '#6A8991' }}>...</span>
				);
				pages.push(
					<button
						key={totalPages}
						onClick={() => handlePageChange(totalPages)}
						style={{
							padding: '8px 6px',
							border: 'none',
							backgroundColor: 'transparent',
							color: '#6A8991',
							fontWeight: 400,
							borderRadius: '4px',
							fontSize: 14,
							cursor: 'pointer',
						}}
					>
						{totalPages}
					</button>
				);
			}
		}
		
		return pages;
	};

	return (
		<div style={{ 
			display: 'flex', 
			justifyContent: 'space-between', 
			alignItems: 'center', 
			padding: '20px 0',
			flexWrap: 'wrap',
			gap: '10px'
		}}>
			{showPageSizeSelector && (
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<span style={{ fontWeight: 500, fontSize: 14 }}>Show:</span>
					<select
						value={pageSize}
						onChange={(e) => onPageSizeChange(parseInt(e.target.value))}
						style={{
							padding: '8px',
							border: '1px solid #ccc',
							borderRadius: '4px',
							width: '60px',
						}}
						className="select-primary"
					>
						<option value={10}>10</option>
						<option value={25}>25</option>
						<option value={50}>50</option>
						<option value={100}>100</option>
					</select>
				</div>
			)}
			
			{showInfo && (
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					<span style={{ color: '#062229', fontWeight: 700, fontSize: 14 }}>
						{((currentPage - 1) * pageSize) + 1} - {Math.min(currentPage * pageSize, totalItems)} of {totalItems} {entityLabel}
					</span>
				</div>
			)}
			
			<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
				<div style={{ marginBottom: -1 }}>
					<button
						onClick={() => handlePageChange(1)}
						disabled={currentPage === 1}
						style={{
							padding: '8px 2px',
							border: 'none',
							backgroundColor: 'transparent',
							cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
						}}
					>
						<Icon name="chevrons-left" font="Feather" size={14} color={currentPage === 1 ? '#ccc' : '#6A8991'} />
					</button>
					<button
						onClick={() => handlePageChange(currentPage - 1)}
						disabled={currentPage === 1}
						style={{
							padding: '8px 2px',
							border: 'none',
							backgroundColor: 'transparent',
							cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
						}}
					>
						<Icon name="chevron-left" font="Feather" size={14} color={currentPage === 1 ? '#ccc' : '#6A8991'} />
					</button>
				</div>
				
				{/* Page Numbers */}
				{renderPageNumbers()}

				<div style={{ marginBottom: -1 }}>
					<button
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={currentPage === totalPages}
						style={{
							padding: '8px 2px',
							border: 'none',
							backgroundColor: 'transparent',
							cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
						}}
					>
						<Icon name="chevron-right" font="Feather" size={14} color={currentPage === totalPages ? '#ccc' : '#6A8991'} />
					</button>
					<button
						onClick={() => handlePageChange(totalPages)}
						disabled={currentPage === totalPages}
						style={{
							padding: '8px 2px',
							border: 'none',
							backgroundColor: 'transparent',
							cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
						}}
					>
						<Icon name="chevrons-right" font="Feather" size={14} color={currentPage === totalPages ? '#ccc' : '#6A8991'} />
					</button>
				</div>
			</div>
		</div>
	);
};

export default Pagination; 